import {
  RETIREMENT_GENERAL_AGES,
  RETIREMENT_GENERAL_EXPENSES,
  RETIREMENT_GENERAL_LIFE_EXPECTANCIES,
  RETIREMENT_ADDITIONAL_SAVINGS_ADDITIONAL_SAVINGS,
  RETIREMENT_DISTRIBUTIONS_DISTRIBUTIONS,
  RETIREMENT_ASSET_ALLOCATIONS_ASSET_ALLOCATION_PRE,
  RETIREMENT_ASSET_ALLOCATIONS_ASSET_ALLOCATION_POST,
  RETIREMENT_SOCIAL_SECURITY_MONTHLY_BENEFITS,
  RETIREMENT_STRESS_TEST_INFLATION_CHANGES,
  RETIREMENT_STRESS_TEST_MARKET_DROPS,
  RETIREMENT_ROTH_CONVERSION,
  EDUCATION_ADDITIONAL_SAVINGS_ADDITIONAL_SAVINGS,
  LARGE_PURCHASE_ADDITIONAL_SAVINGS_ADDITIONAL_SAVINGS,
  EMERGENCY_FUND_ADDITIONAL_SAVINGS_ADDITIONAL_SAVINGS,
  HEALTH_CARE_ADDITIONAL_SAVINGS_ADDITIONAL_SAVINGS,
  HOME_PURCHASE_ADDITIONAL_SAVINGS_ADDITIONAL_SAVINGS,
  EDUCATION_ASSET_ALLOCATIONS_ASSET_ALLOCATION,
  LARGE_PURCHASE_ASSET_ALLOCATIONS_ASSET_ALLOCATION,
  HEALTH_CARE_ASSET_ALLOCATIONS_ASSET_ALLOCATION,
  HOME_PURCHASE_ASSET_ALLOCATIONS_ASSET_ALLOCATION,
  EMERGENCY_FUND_GENERAL_TARGET_AMOUNT,
  EMERGENCY_FUND_GENERAL_GOAL_YEAR,
  HOME_PURCHASE_GENERAL_PURCHASE_YEAR,
  HOME_PURCHASE_GENERAL_MORTGAGE_TYPE,
  HOME_PURCHASE_GENERAL_MORTGAGE_INTEREST_RATE,
  HOME_PURCHASE_GENERAL_DOWN_PAYMENT,
  HOME_PURCHASE_GENERAL_HOME_VALUE,
  HOME_PURCHASE_ASSUMPTIONS_TAX_RATES,
  HOME_PURCHASE_ASSUMPTIONS_PMI,
  HOME_PURCHASE_ASSUMPTIONS_HOME_INSURANCE,
  HOME_PURCHASE_ASSUMPTIONS_HOA,
  HEALTH_CARE_GENERAL_YEAR,
  HEALTH_CARE_GENERAL_PRICE,
  HEALTH_CARE_GENERAL_INFLATION,
  DEBT_MANAGEMENT_ADDITIONAL_SAVINGS_ADDITIONAL_SAVINGS,
  DEBT_MANAGEMENT_STRATEGY_REPLAYMENT,
  DEBT_MANAGEMENT_REFINANCE,
  EDUCATION_GENERAL_SCHOOL_TYPE,
  EDUCATION_GENERAL_SCHOOL_YEARS,
  LARGE_PURCHASE_GENERAL_GOAL_YEAR,
  LARGE_PURCHASE_GENERAL_PRICE_CHANGES,
  LARGE_PURCHASE_GENERAL_PURCHASE_FREQUENCY,
  INSURANCE_LIFE_LIFE_INSURANCE_LIVING_EXPENSES,
  INSURANCE_LIFE_LIFE_INSURANCE_EMPLOYMENT_INCOME,
  INSURANCE_LIFE_LIFE_INSURANCE_COVERAGE,
  INSURANCE_LONG_TERM_CARE_LONG_TERM_CARE_NEEDS,
  INSURANCE_LONG_TERM_CARE_LONG_TERM_CARE_COST,
  INSURANCE_LONG_TERM_CARE_LONG_TERM_CARE_ADDITIONAL_COVERAGE,
  DECUMULATION_DISTRIBUTION_AMOUNT,
  DECUMULATION_DISTRIBUTION_YEARS,
} from './WhatIfsConstants';

export default {
  [RETIREMENT_GENERAL_AGES]: '',
  [RETIREMENT_GENERAL_LIFE_EXPECTANCIES]: '',
  [RETIREMENT_GENERAL_EXPENSES]: '',
  [RETIREMENT_DISTRIBUTIONS_DISTRIBUTIONS]: '',
  [RETIREMENT_ADDITIONAL_SAVINGS_ADDITIONAL_SAVINGS]: 'WhatIfRetirementAdditionalSavings',
  [RETIREMENT_ASSET_ALLOCATIONS_ASSET_ALLOCATION_PRE]: 'WhatIfRetirementAssetAllocationPre',
  [RETIREMENT_ASSET_ALLOCATIONS_ASSET_ALLOCATION_POST]: 'WhatIfRetirementAssetAllocationPost',
  [RETIREMENT_SOCIAL_SECURITY_MONTHLY_BENEFITS]: 'WhatIfRetirementSocialSecurityMonthlyBenefits',
  [RETIREMENT_STRESS_TEST_INFLATION_CHANGES]: 'WhatIfRetirementStressTestInflation',
  [RETIREMENT_STRESS_TEST_MARKET_DROPS]: 'WhatIfRetirementStressTestMarketDrop',
  [RETIREMENT_ROTH_CONVERSION]: 'WhatIfRetirementRothConversion',
  [EDUCATION_ADDITIONAL_SAVINGS_ADDITIONAL_SAVINGS]: 'WhatIfEducationAdditionalSavings',
  [LARGE_PURCHASE_ADDITIONAL_SAVINGS_ADDITIONAL_SAVINGS]: 'WhatIfLargePurchaseAdditionalSavings',
  [EMERGENCY_FUND_ADDITIONAL_SAVINGS_ADDITIONAL_SAVINGS]: 'WhatIfEmergencyFundAdditionalSavings',
  [HEALTH_CARE_ADDITIONAL_SAVINGS_ADDITIONAL_SAVINGS]: 'WhatIfHealthCareAdditionalSavings',
  [HOME_PURCHASE_ADDITIONAL_SAVINGS_ADDITIONAL_SAVINGS]: 'WhatIfHomePurchaseAdditionalSavings',
  [EDUCATION_ASSET_ALLOCATIONS_ASSET_ALLOCATION]: 'WhatIfEducationAssetAllocation',
  [LARGE_PURCHASE_ASSET_ALLOCATIONS_ASSET_ALLOCATION]: 'WhatIfLargePurchaseAssetAllocation',
  [HEALTH_CARE_ASSET_ALLOCATIONS_ASSET_ALLOCATION]: 'WhatIfHealthCareAssetAllocation',
  [HOME_PURCHASE_ASSET_ALLOCATIONS_ASSET_ALLOCATION]: 'WhatIfHomePurchaseAssetAllocation',
  [EMERGENCY_FUND_GENERAL_TARGET_AMOUNT]: 'WhatIfEmergencyFundAmount',
  [EMERGENCY_FUND_GENERAL_GOAL_YEAR]: 'WhatIfEmergencyFundYear',
  [HOME_PURCHASE_GENERAL_PURCHASE_YEAR]: 'WhatIfHomePurchaseYear',
  [HOME_PURCHASE_GENERAL_MORTGAGE_TYPE]: 'WhatIfHomePurchaseMortgageType',
  [HOME_PURCHASE_GENERAL_MORTGAGE_INTEREST_RATE]: 'WhatIfHomePurchaseMortgageInterestRate',
  [HOME_PURCHASE_GENERAL_DOWN_PAYMENT]: 'WhatIfHomePurchaseDownPayment',
  [HOME_PURCHASE_GENERAL_HOME_VALUE]: 'WhatIfHomePurchaseValue',
  [HOME_PURCHASE_ASSUMPTIONS_TAX_RATES]: 'WhatIfHomePurchaseAssumptionsPropertyTax',
  [HOME_PURCHASE_ASSUMPTIONS_PMI]: 'WhatIfHomePurchaseAssumptionsPmi',
  [HOME_PURCHASE_ASSUMPTIONS_HOME_INSURANCE]: 'WhatIfHomePurchaseAssumptionsHomeInsurance',
  [HOME_PURCHASE_ASSUMPTIONS_HOA]: 'WhatIfHomePurchaseAssumptionsHoa',
  [HEALTH_CARE_GENERAL_YEAR]: 'WhatIfHealthCareYear',
  [HEALTH_CARE_GENERAL_PRICE]: 'WhatIfHealthCareCost',
  [HEALTH_CARE_GENERAL_INFLATION]: 'WhatIfHealthCareInflation',
  [DEBT_MANAGEMENT_ADDITIONAL_SAVINGS_ADDITIONAL_SAVINGS]: 'WhatIfDebtManagementAdditionalSavings',
  [DEBT_MANAGEMENT_STRATEGY_REPLAYMENT]: 'WhatIfDebtManagementStrategy',
  [DEBT_MANAGEMENT_REFINANCE]: 'WhatIfDebtManagementRefinance',
  [EDUCATION_GENERAL_SCHOOL_TYPE]: 'WhatIfEducationSchoolType',
  [EDUCATION_GENERAL_SCHOOL_YEARS]: 'WhatIfEducationDurationYears',
  [LARGE_PURCHASE_GENERAL_GOAL_YEAR]: 'WhatIfLargePurchaseYear',
  [LARGE_PURCHASE_GENERAL_PRICE_CHANGES]: 'WhatIfLargePurchasePrice',
  [LARGE_PURCHASE_GENERAL_PURCHASE_FREQUENCY]: 'WhatIfLargePurchaseFrequency',
  [INSURANCE_LIFE_LIFE_INSURANCE_LIVING_EXPENSES]: 'WhatIfLifeInsuranceLivingExpenses',
  [INSURANCE_LIFE_LIFE_INSURANCE_EMPLOYMENT_INCOME]: 'WhatIfLifeInsuranceEmploymentIncome',
  [INSURANCE_LIFE_LIFE_INSURANCE_COVERAGE]: 'WhatIfLifeInsuranceCoverage',
  [INSURANCE_LONG_TERM_CARE_LONG_TERM_CARE_NEEDS]: 'WhatIfInsuranceLtcNeeds',
  [INSURANCE_LONG_TERM_CARE_LONG_TERM_CARE_COST]: 'WhatIfInsuranceLtcCost',
  [INSURANCE_LONG_TERM_CARE_LONG_TERM_CARE_ADDITIONAL_COVERAGE]:
    'WhatIfInsuranceLtcAdditionalCoverage',
  [DECUMULATION_DISTRIBUTION_AMOUNT]: 'WhatIfDecumulationDistributionAmount',
  [DECUMULATION_DISTRIBUTION_YEARS]: 'WhatIfDecumulationDistributionYears',
};
